import { DynamicParams } from '@config/react-router-dom/hooks/query-params.types';
import { CourseData } from '@containers/activity-router/data-grid-container/courses/types/courses.types';
import { RouteHelpersModalConstants } from '@containers/activity-router/routes/helpers/modal/route-modal-helpers.types';
import { DefaultState } from '@containers/activity-router/routes/helpers/slice/slice.types';
import {
    ChallengesFilterLevel
} from '@containers/activity-router/routes/learn/challenges/components/challenges-ui-filters/level-filter/level-filter.types';
import {
    ChallengesPlaylist
} from '@containers/activity-router/routes/learn/challenges/components/challenges-ui-filters/playlist-filter/playlist-filter.types';
import {
    ChallengesComplexity,
    TransformedChallengesAssignments
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';

export enum ChallengesConstants {
    name = 'challenges'
}

export type ChallengesState = DefaultState & {
    course: {
        selected: DefaultState['course']['selected']
        filtered: CourseData
    }
    filters: {
        level: ChallengesFilterLevel
        dok: Array<ChallengesComplexity>
        strand: string[]
        topic: string[]
        playlist: ChallengesPlaylist
        isExpanded: boolean
        // Dynamic params act as triggers from the portal; this array tracks which have been actioned
        dynamicParams: Array<DynamicParams>
    }
    assignments: {
        grid: TransformedChallengesAssignments
    }
    modal: RouteHelpersModalConstants | null
};
